import styled from 'styled-components';

export const ContentStyles = styled.div`
  width: 100%;
  margin: 20px auto 0;
  padding: 0 24px 24px;

  .btn-remove-all-data {
    margin-top: 24px;
  }
`;

export const WebVersionLinkStyles = styled.div`
  width: 100%;
  border-radius: 6px;
  border: 1px solid #a6a6a6;
  background: #000;
  color: #fff;
  padding: 8px 16px;
  max-width: 380px;
  width: 100%;
  margin: 0 auto 14px;

  a {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: inherit;
    font-weight: bold;
    text-decoration: none;

    ion-icon {
      font-size: 24px;
    }
  }
`;
